import ConfirmEmail from "./confirm-email";

export default ConfirmEmail;